/**
 * Composants VUE
 */
import { Vue, Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

/**
 * Classes et énumérations
 */
import { SMACertificate } from '@/types/Administration/SMA/SMACertificate';

/**
 * Stratégie de signature et récupération du mandat
 */
import { AbstractSignatureStrategy } from './SigningUpCerticate/AbstractSignatureStrategy';
import { SignatureStrategyFactory } from './SigningUpCerticate/SignatureStrategyFactory';

/**
 * Utilitaire
 */
import { SMAUtils } from '../SMAUtils';
/**
 * Elements commun pour les différentes options de validation des mandats
 */
@Component
export class CertificateValidation extends mixins(Vue, SMAUtils) {

    /**
     * Mandat
     */
    @Prop() 
    protected Certificate!: SMACertificate;

    /**
     * Variant
     */
    @Prop({ default: 'quartary' })
    protected Variant!: string;

    /**
     * Stratégie de récupération du mandat
     * Default ==> Récupération via l'interface de mandats
     * SessionLess ==> Récupération par la page de signature et du token via E-mail
     */
    @Prop({ default: "SessionLessSignature" })
    public Strategy!: "DefaultSignature" | "SessionLessSignature";

    /**
     * Instance de la stratégie à utiliser pour la signature du document
     */
    public strategy: AbstractSignatureStrategy = null;
    
    protected uploadedFile: File[] = [];                                 // Stockage temporaire du mandat
    protected stepIndex: number = 0;                                            // 0: Import, 1: Password
    protected isVisible: boolean = true;                                        // Affichage de la fenêtre du composant
    protected isSending: boolean = false;                                       // Envoi en cours

    protected signedPdfBlob: Blob[] = [];                                       // mandat pdf signé (format blob)
    protected SignedPdf: string | null = null;                                  // Pdf format base 64
    protected enableSignDocument: boolean = true;                               // Enable la signature suite signature client
    protected uploadedSignatureBase64: string | null = null;                    // Pdf mis à jour suite à signature

    protected Source!: Blob;                                                    // Source du pdf

    /**
     * Sauvegarde de la signature
     * et
     * Si Valide => Event de validation emit au composant parent 
     * Si non Valide =>  message d'erreur
     */
    protected async saveCustomerSignature(password: string) {
        console.debug("saveCustomerSignature");

        this.isSending = true;

        const base64String = await new Promise<string>((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result as string);
            reader.onerror = reject;
            reader.readAsDataURL(this.signedPdfBlob[0]);
        });

        const rawBase64 = base64String.includes(',') ? base64String.split(',')[1] : base64String;
        
        await this.strategy.validation({ 
            Certificate: this.Certificate,
            Base64File: rawBase64,
            Password: password
        }).then((result) => {
            this.isSending = false;

            this.$bvModal.msgBoxOk(result.message, {
                title: result.success ? "Succès" : "Erreur",
                size: 'sm',
                buttonSize: 'sm',
                okVariant: result.success ? 'success' : 'danger',
                headerClass: result.success ? 'p-2 border-bottom-0' : 'p-2 border-bottom-0 text-danger',
                footerClass: 'p-2 border-top-0',
                centered: true
            })
            .then(() => {
                if(result.success){
                    this.$emit("validation");
                    this.isVisible = false;
                }
            });
        });
    }

    /**
     * Submit de la signature superviseur
     * @param password mot de passe
     */
    protected async saveSupervisorSignature(password: string){
        console.debug("saveSupervisorSignature");

        await this.strategy.validation({ 
            Certificate: this.Certificate,
            Password: password
        }).then((result) => {
            this.isSending = false;

            console.debug("Final signature data:", result);

            this.$bvModal.msgBoxOk(result.message, {
                title: result.success ? "Succès" : "Erreur",
                size: 'sm',
                buttonSize: 'sm',
                okVariant: result.success ? 'success' : 'danger',
                headerClass: result.success ? 'p-2 border-bottom-0' : 'p-2 border-bottom-0 text-danger',
                footerClass: 'p-2 border-top-0',
                centered: true
            })
            .then(() => {
                if(result.success){
                    this.$emit("validation");
                    this.isVisible = false;
                }
            });
        });
    }

    /**
     * Initialisation du composant
     * => Récupération du mandat suivant la stratégie
     */
    protected async init(){
      this.strategy = SignatureStrategyFactory.getStrategy(this.Strategy, this.$store)
      
      if(this.strategy){
        this.strategy.execute({ item: this.Certificate, resource: this.Certificate?.Resources }).then((response) => {
            if(response == null)
                return;
            
            this.Source = response.data;
            if (this.Source) this.SignedPdf = URL.createObjectURL(this.Source);
            
            if(!response.success){
                this.enableSignDocument = false;
                
                this.$bvModal.msgBoxOk(response.message, {
                    title: "Information",
                    buttonSize: 'sm',
                    centered: true,
                    size: 'sm',
                    noCloseOnBackdrop: true,
                    noCloseOnEsc: true,
                    hideHeaderClose: true,
                    footerClass: 'd-none',
                    headerClass: 'p-2 border-bottom-0 d-flex justify-content-center',
                })
            }
        })
      }
    }
}